//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AppCardCode from '@core/components/app-card-code/AppCardCode.vue'

// demos
import DemoMenuBasic from './demos/DemoMenuBasic.vue'
import DemoMenuPosition from './demos/DemoMenuPosition.vue'
import DemoMenuCloseOn from './demos/DemoMenuCloseOn.vue'
import DemoMenuDisabled from './demos/DemoMenuDisabled.vue'
import DemoMenuHover from './demos/DemoMenuHover.vue'
import DemoMenuTooltip from './demos/DemoMenuTooltip.vue'
import DemoMenuTransitions from './demos/DemoMenuTransitions.vue'
import DemoMenuPopover from './demos/DemoMenuPopover.vue'

// code
import {
  menuBasic,
  menuPosition,
  menuCloseOn,
  menuDisabled,
  menuHover,
  menuTooltip,
  menuTransitions,
  menuPopover,
} from './demos/code'

export default {
  components: {
    AppCardCode,
    DemoMenuBasic,
    DemoMenuPosition,
    DemoMenuCloseOn,
    DemoMenuDisabled,
    DemoMenuHover,
    DemoMenuTooltip,
    DemoMenuTransitions,
    DemoMenuPopover,
  },
  setup() {
    return {
      codeSnippets: {
        menuBasic,
        menuPosition,
        menuCloseOn,
        menuDisabled,
        menuHover,
        menuTooltip,
        menuTransitions,
        menuPopover,
      },
    }
  },
}
